import React from 'react';
import { Button, Flex, Text, View } from '@smarterservices/smarter-ui';
import { config } from '../../config';

const NewerTabDetected = () => {
  return (
  <Flex
    direction="column"
    justifyItems="center"
    alignItems="center"
    height="100vh"
    width="100%"
    padding="large"
  >
    <View
      as="div"
      width="75%"
      maxWidth="500px"
      padding="x-large"
      shadow="resting"
      borderRadius="medium"
      background="primary"
    >
      <Flex direction="column" gap="large" alignItems="center" textAlign="center">
        <Text size="x-large" weight="bold" color="primary">
          Multiple Onboarding Tabs Detected
        </Text>

        <Text size="medium" lineHeight="default">
          To continue onboarding for your proctoring session, click the Install Extension button below. After installation, you will be automatically directed to the correct onboarding tab.
        </Text>

        <Flex direction="column" gap="medium" width="100%">
          <Button
            color="primary"
            size="medium"
            onClick={() => {
              const url = config?.session?.extensionDownloadLink;
              if (url) {
                window.location.replace(url);
              }
            }}
            width="100%"
          >
            Install Extension
          </Button>
        </Flex>
      </Flex>
    </View>
  </Flex>
  );
};

export default NewerTabDetected;
